import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';

import { ConnectedDocumentService } from './connected-document-base.service';
import { CompanyDocument } from '../../model/company-document';

@Injectable()
export class CompanyDocumentService extends ConnectedDocumentService<CompanyDocument> {
  constructor(client: HttpClient, messageService: MessageService, progressBar: ProgressBarService, @Inject(APP_CONFIG) config: IAppConfig) {
    super(client, messageService, progressBar, 'company-documents', config);
  }

  createModel(): CompanyDocument {
    return new CompanyDocument();
  }
}
